import { useContext } from "react";
import PhoneInput from "react-phone-number-input";
import styles from "./Login.module.scss";
import closebtnImg from "../../assets/images/close.png";
import clipBoardBtnImg from "../../assets/images/clipb.png";
import LoaderImg from "../../assets/images/Loader.gif";
import { authContext } from "../../contexts/AuthContext/AuthContextProvider";
import { Link, useLocation, useHistory, useParams } from "react-router-dom";
import { handleCaretPosition, windowOpenUrl } from "../../utils/common.utils";
import { openRoutes, whiteListCountries } from "../../AppConstants/Constants";

const Login = ({ old }) => {
  const history = useHistory();
  const { pathname, search = "", hash = "" } = useLocation();
  const { webinarID } = useParams();

  const {
    toggleSignInbtn,
    handlePhoneNumber,
    handleLoginBtn,
    state,
    updateMultipleState,
    toggleSignUpBtn,
    DefaultFormDetails,
  } = useContext(authContext);
  const { error, userDisabledError, errors, formDetails, loading } = state;
  const { phoneNumber } = formDetails;

  const handleRegisterBtn = () => {
    if (pathname.includes("/webinar/")) {
      localStorage.setItem("registeration_source", webinarID);
    }
    if (old) {
      toggleSignUpBtn();
    } else {
      let obj = {
        showJoinModal: true,
        showSignInModal: false,
        error: false,
      };
      updateMultipleState(obj);
    }
  };

  const closeSignInModal = () => {
    let obj = {
      error: false,
      showSignInModal: false,
      formDetails: DefaultFormDetails,
    };
    updateMultipleState(obj);
    // toggleSignInbtn("showSignInModal", false);
  };

  const isFromExclusiveSeason =
    sessionStorage.getItem("exclusiveSeason") == "true";

  const exists =
    openRoutes.some((hideRoute) => pathname.includes(hideRoute)) &&
    window?.clientId?.toString().replaceAll(".", "") &&
    !isFromExclusiveSeason;

  const handleCloseModal = () => {
    closeSignInModal();
    if (isFromExclusiveSeason) history.replace("/");
    else {
      closeSignInModal();
    }
  };
  return !error ? (
    <div className={`modalOverlayWithBlur ${styles["container"]}`}>
      <div className={styles["box"]}>
        {exists ? (
          <h2>
            To Continue Watching
            <br />
            Please Login
          </h2>
        ) : isFromExclusiveSeason ? (
          <h2>
            <p className={styles.loginToAccess}>Login to Access</p>
            <p className={styles.ExclusiveContent}>Exclusive Content</p>
          </h2>
        ) : (
          <h1>Start Watching</h1>
        )}
        <form onSubmit={handleLoginBtn} className={styles["signin-form"]}>
          <div className={styles["input-group"]}>
            <label htmlFor="phone">Mobile Number</label>
            <PhoneInput
              defaultCountry={whiteListCountries[0]}
              international
              addInternationalOption={false}
              countryCallingCodeEditable={false}
              limitMaxLength
              // countries={whiteListCountries}
              withCountryCallingCode
              className="form-control"
              name="phoneNumber"
              value={phoneNumber}
              id="phone"
              placeholder="Enter Mobile Number"
              onChange={handlePhoneNumber}
              onKeyDown={handleCaretPosition}
              onClick={handleCaretPosition}
              onFocus={() => {
                let obj = {
                  errors: false,
                  loading: false,
                };
                updateMultipleState(obj);
              }}
            />
          </div>
          <div className={styles["terms"]}>
            By proceeding you agree to the{" "}
            <Link to={"/terms-of-use"} target="_blank">
              <span>Terms of use</span>{" "}
            </Link>
            and{" "}
            <span
              onClick={() =>
                windowOpenUrl("https://www.mankindpharma.com/privacy-policy")
              }
            >
              Privacy Policy
            </span>
            .
          </div>
          {errors && <div className="error">{errors}</div>}
          <button disabled={loading} className={`btn ${styles["submit-btn"]}`}>
            {loading ? <img src={LoaderImg} alt="" height="100%" /> : "Submit"}
          </button>
        </form>
        {!exists && (
          <div onClick={handleCloseModal} className={styles["closeBtn"]}>
            <img src={closebtnImg} alt="close" />
          </div>
        )}
        <div className={styles["sinupbtn-container"]}>
          Don’t have an account?{" "}
          <span className={styles.registerText} onClick={handleRegisterBtn}>
            Register now.
          </span>
        </div>
      </div>
    </div>
  ) : (
    <div className={`modalOverlayWithBlur ${styles["container"]}`}>
      <div className={`text-align-center ${styles["box"]}`}>
        <h1 className={styles["not-registered-heading"]}>Don’t be missed</h1>
        <div className={styles["signin-form"]} style={{ alignItems: "center" }}>
          <div className={styles["not-registered"]}>
            It seems that{" "}
            <span className={styles["not-registered-number"]}>
              {phoneNumber}
            </span>
            <br />
            is not registered with us.
          </div>
          <div className={styles["not-registered-img"]}>
            <img src={clipBoardBtnImg} alt="" />
          </div>
          <div>Would you like to register it with Docflix?</div>
          <div className={styles["formbtns"]}>
            <button
              onClick={handleRegisterBtn}
              className={`btn ${styles["submit-btn"]}`}
            >
              Register Now
            </button>
            <button
              className={`btn ${styles["notnow-btn"]}`}
              onClick={closeSignInModal}
            >
              Not Now
            </button>
          </div>
        </div>
        {!exists && (
          <div onClick={closeSignInModal} className={styles["closeBtn"]}>
            <img src={closebtnImg} alt="close" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
